import type { Control, FieldValue, FieldValues } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import type { InputNumberProps } from './InputNumber'
import InputNumber from './InputNumber'

interface HFInputNumberProps extends InputNumberProps {
  name: string
  control: Control<FieldValue<FieldValues>>
}

function HFInputNumber({ name, control, required, ...rest }: HFInputNumberProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <div className='field'>
            <InputNumber
              {...rest}
              value={field.value}
              onChange={value => field.onChange(value)}
              required={required}
              error={fieldState.invalid}
            />
            {required && fieldState.invalid && <p className='error-label'>{fieldState.error?.message}</p>}
          </div>
        )
      }}
    />
  )
}

export default HFInputNumber
